export default [{
  path: '/social',
  name: 'social',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/social/index')
}]
